
import MutilForm from "./components/Multiform"
const App = () => {
  return (
    <div>
      <MutilForm/>
    </div>
  )
}

export default App